"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SavedCardsDialog = SavedCardsDialog;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _elements = require("@reservamos/elements");
var _reactI18next = require("react-i18next");
var _PendingCardDeletionNotice = require("./PendingCardDeletionNotice");
var _SavedPaymentCard = require("./SavedPaymentCard");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/** Preserve selection inside the dialog until the same explicit confirmation as the reference UI. */
function SavedCardsDialog(_ref) {
  var cards = _ref.cards,
    currentSelectedCardId = _ref.currentSelectedCardId,
    deleteDisabled = _ref.deleteDisabled,
    onClose = _ref.onClose,
    onConfirmSelection = _ref.onConfirmSelection,
    onDeleteCard = _ref.onDeleteCard,
    _onOpenDeleteMode = _ref.onOpenDeleteMode,
    onUndoDeleteCard = _ref.onUndoDeleteCard,
    pendingDeleteCardId = _ref.pendingDeleteCardId,
    pendingDeleteRemainingSeconds = _ref.pendingDeleteRemainingSeconds,
    visible = _ref.visible;
  var _useTranslation = (0, _reactI18next.useTranslation)('purchase'),
    t = _useTranslation.t;
  var _useState = (0, _react.useState)(currentSelectedCardId !== null && currentSelectedCardId !== void 0 ? currentSelectedCardId : ''),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    temporaryCardId = _useState2[0],
    setTemporaryCardId = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    deleteModeCardId = _useState4[0],
    setDeleteModeCardId = _useState4[1];
  (0, _react.useEffect)(function () {
    if (!visible) return;
    setTemporaryCardId(currentSelectedCardId !== null && currentSelectedCardId !== void 0 ? currentSelectedCardId : '');
    setDeleteModeCardId(undefined);
  }, [currentSelectedCardId, visible]);
  if (!visible) return null;
  return /*#__PURE__*/_react["default"].createElement(_elements.Modal, {
    responsiveSize: "auto",
    contentHeight: "auto",
    expandedModal: true,
    rounded: "M",
    removeContentPadding: true,
    visible: visible,
    showCloseButton: false,
    onCloseModal: onClose,
    "data-sentry-element": "Modal",
    "data-sentry-component": "SavedCardsDialog",
    "data-sentry-source-file": "SavedCardsDialog.tsx"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-[900px] max-w-[calc(100vw-120px)] px-[30px] pb-3 pt-6 max-sm:w-full max-sm:max-w-none max-sm:p-5"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center justify-between pb-6 pt-1"
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: "m-0 text-xl font-bold leading-tight text-gray-700"
  }, t('saved_card.choose_card')), /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "flex h-9 w-9 items-center justify-center rounded-full border-0 bg-transparent",
    "aria-label": t('saved_card.close'),
    onClick: onClose
  }, /*#__PURE__*/_react["default"].createElement(_elements.Icon, {
    type: "Close",
    color: "primary",
    size: "S",
    "data-sentry-element": "Icon",
    "data-sentry-source-file": "SavedCardsDialog.tsx"
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col gap-3"
  }, pendingDeleteCardId && /*#__PURE__*/_react["default"].createElement(_PendingCardDeletionNotice.PendingCardDeletionNotice, {
    onUndo: onUndoDeleteCard,
    remainingSeconds: pendingDeleteRemainingSeconds
  }), cards.map(function (card) {
    return /*#__PURE__*/_react["default"].createElement(_SavedPaymentCard.SavedPaymentCard, {
      key: card.id,
      card: card,
      deleteDisabled: deleteDisabled,
      idPrefix: "saved-card-dialog",
      isActive: temporaryCardId === card.id,
      toDelete: deleteModeCardId === card.id,
      onSelect: function onSelect() {
        if (card.isExpired) return;
        setTemporaryCardId(function (currentCardId) {
          return currentCardId === card.id ? '' : card.id;
        });
      },
      onOpenDeleteMode: function onOpenDeleteMode() {
        if (!deleteDisabled) {
          _onOpenDeleteMode(card);
          setDeleteModeCardId(card.id);
        }
      },
      onCloseDeleteMode: function onCloseDeleteMode() {
        return setDeleteModeCardId(undefined);
      },
      onConfirmDelete: function onConfirmDelete() {
        onDeleteCard(card);
        setDeleteModeCardId(undefined);
        if (temporaryCardId === card.id) setTemporaryCardId('');
      }
    });
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-end pb-1 pt-[18px]"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-full sm:w-[52%] sm:max-w-[420px]"
  }, /*#__PURE__*/_react["default"].createElement(_elements.Button, {
    text: t('saved_card.confirm'),
    variant: "primary",
    withHeight: true,
    fullWidth: true,
    onClick: function onClick() {
      return onConfirmSelection(temporaryCardId);
    },
    minHeight: "48px",
    "data-sentry-element": "Button",
    "data-sentry-source-file": "SavedCardsDialog.tsx"
  }))))));
}